import ChatIcon from "assets/svg/ChatIcon.svg";
import styles from "./index.module.css";

export const NoChatComponent = () => {
  return (
    <div className={styles.wrapper}>
      <img src={ChatIcon} alt="chatIcon" />
      <div>Choose a Chat to start conversation</div>
    </div>
  );
};
